<div id="general" class="category-content active">
    <div class="stats-grid">
        <div class="stat-card">
            <span class="stat-number">26</span>
            <div class="stat-label">Septiembre 2026</div>
        </div>
        <div class="stat-card">
            <span class="stat-number">17</span>
            <div class="stat-label">Jugadoras Inscritas</div>
        </div>
        <div class="stat-card">
            <span class="stat-number">2</span>
            <div class="stat-label">Categorias</div>
        </div>
        <div class="stat-card">
            <span class="stat-number">4</span>
            <div class="stat-label">Grupos</div>
        </div>
    </div>

    <div class="rules-grid">
        <div class="rule-card">
            <div>
                <svg width="80px" height="80px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 17V11" stroke="#c8007f" stroke-width="1.5" stroke-linecap="round" />
                    <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 11 9)" fill="#c8007f" />
                    <path
                        d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
                        stroke="#c8007f" stroke-width="1.5" stroke-linecap="round" />
                </svg>
            </div>
            <div class="rule-list">
                <ul>
                    <li>Torneo especial de damas con dos categorías: <strong>Damas A</strong> y <strong>Damas B</strong>, cada una con grupos A y B.</li>
                    <li>Este torneo no otorga puntos de ranking.</li>
                    <li>Todos los partidos se jugarán a 2 de 3 games.</li>
                    <li>Uso de gafas es obligatorio.</li>
                    <li>El buen comportamiento es fundamental para el buen desarrollo del torneo; la buena conducta deportiva hace que nuestro deporte sea más sano y familiar.</li>
                    <li>Por favor llegar puntual a sus partidos.</li>
                </ul>
            </div>
        </div>
    </div>

    <h3 style="margin-bottom: 20px; color: #c8007f; text-align: center;">Programación por bloques</h3>

    <div class="tab-content" style="display: block; margin-bottom: 2rem;">
        <h3 style="margin-bottom: 20px; color: #c8007f;">Sábado 26 de Septiembre 2026</h3>

        <div class="info-schedule">
            <div class="info">
                <div class="time"><span>desde</span>8:00 a.m. <br><span>hasta</span>1:00 p.m.</div>
                <div class="players">Damas A / Damas B: fase de grupos, semifinales y final</div>
            </div>
        </div>
    </div>
</div>
